/// <reference types="@angular/localize" />

import {HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {provideRouter, Router} from '@angular/router';
import { HttpRequestsInterceptor } from '@shared/interceptors/http-requests.interceptor';
import { provideNgxWebstorage, withLocalStorage, withNgxWebstorageConfig, withSessionStorage } from 'ngx-webstorage';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { provideToastr } from 'ngx-toastr';
import { environment } from './environments/environment';
import { ErrorHandler, importProvidersFrom} from "@angular/core";
import {BackendFetch, DevTools, Tolgee, TOLGEE_INSTANCE} from "@tolgee/ngx";
import {FormatIcu} from "@tolgee/format-icu";
import * as Sentry from '@sentry/angular';

if (environment.production) {
    Sentry.init({
        dsn: environment.sentryDsn,
        release: environment.version,
        environment: environment.production ? 'production' : 'development',
        debug: !environment.production,
        integrations: [
        ],
    });
}

function trimSlashes(path: string) {
    if (path.endsWith('/')) {
        return path.slice(0, -1);
    }
    return path;
}

const tolgeeGetPath:any = (options:{namespace: any, language: any, prefix: any }) => {
    const {namespace, language, prefix } = options;
    const timestamp = Date.now();
    if (namespace) {
        return `${trimSlashes(prefix)}/${namespace}/${language}.json?t=${timestamp}`;
    } else {
        return `${trimSlashes(prefix)}/${language}.json?t=${timestamp}`;
    }
};


bootstrapApplication(AppComponent, {
    providers: [
        provideRouter(routes),
        provideAnimationsAsync(),
        provideHttpClient(
            withInterceptorsFromDi()
        ),
        provideNgxWebstorage(
			withNgxWebstorageConfig({
                prefix: 'LIS',
                separator: '::',
                caseSensitive: true
            }),
			withLocalStorage(),
            withSessionStorage()
		),
        provideToastr({
            preventDuplicates: true,
            countDuplicates: true
        }),
        { provide: 'environment', useValue: environment },
        { provide: HTTP_INTERCEPTORS, useClass: HttpRequestsInterceptor, multi: true },
        {
            provide: TOLGEE_INSTANCE,
            useFactory: () => {
                let tolgee: any;
                if (environment.name === 'production'){
                    tolgee =  Tolgee()
                        .use(FormatIcu())
                        .use(BackendFetch({prefix: environment.tolgeeCdn, getPath: tolgeeGetPath }))
                        .init({
                            availableLanguages: ['en', 'el'],
                            defaultNs: environment.tolgeeNamespaces?.[0] || 'common',
                            fallbackNs: ['common', ...environment.tolgeeNamespaces],
                            ns: ['common', ...environment.tolgeeNamespaces],
                            language: 'en',
                            fallbackLanguage: 'en'
                        });
                } else {
                    tolgee =  Tolgee()
                        .use(FormatIcu())
                        .use(DevTools())
                        .init({
                            availableLanguages: ['en', 'el'],
                            defaultNs: environment.tolgeeNamespaces?.[0] || 'common',
                            fallbackNs: ['common', ...environment.tolgeeNamespaces],
                            ns: ['common', ...environment.tolgeeNamespaces],
                            language: 'en',
                            fallbackLanguage: 'en',
                            apiUrl: environment.tolgeeApiUrl,
                            apiKey: environment.tolgeeApiKey,
                        });
                }
                tolgee.run();
                return tolgee;
            },
        },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
    ]
}).catch((err) => console.error(err));
